





























































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";


@Component({
  components: {
    Footer, Header
  },
})
export default class NetworkFreight extends Vue {
  content1Title1: string = '网络货运平台/无车承运'
  content1Title2: string = '打造企业专属网络货运平台'
  content1Title3: string = '满足政府监管要求，支持私有化部署，并内置集成了ETC、保险、支付、轨迹、监管、税务、金融等诸多增值服务，支撑实际物流业务'
  content2List: any = [
    {
      img: `/static/compress-img/product/networkFreight/2-1.png`,
      title: "平台搭建",
      content: "标准化平台",
    },
    {
      img: `/static/compress-img/product/networkFreight/2-2.png`,
      title: "资质申报",
      content: "全流程协助资质申报",
    },
    {
      img: `/static/compress-img/product/networkFreight/2-3.png`,
      title: "税务筹划",
      content: "掌握全国多处税源洼地",
    },
    {
      img: `/static/compress-img/product/networkFreight/2-4.png`,
      title: "运营指导",
      content: "资深运营团队指导",
    },
  ]
  content3Title1: string = '申报网络货运'
  content3Title2: string = '的好处'
  content3SubTitle1: string = '提质增效，助力企业转型升级'
  content3SubTitle2: string = '为企业未来发展方向提供数据支持'
  content3List: any = [
    {
      title: '降低运营成本',
      content: '吸引大量社会车辆\n拓展自有运力池'
    },
    {
      title: '进项合规',
      content: '合法取得个体司机运输发票\n真实数据，避免白条风险'
    },
    {
      title: '税企直连',
      content: '无缝对接税务、交通监管平台\n平台涉税数据全程电子化'
    },
    {
      title: '金融赋能',
      content: '基于平台可信订单数据\n帮助企业解决运费垫资难题'
    },
    {
      title: '加速数字化转型',
      content: '大数据云计算分析\n大数据云计算技术\n提升物流服务能力'
    },
    {
      title: '吸引投资',
      content: '丰富的平台数据积累\n直观的数字资产呈现'
    },
  ]
  content4Title1: string = '网络货运'
  content4Title2: string = '资质申报流程'

  content5Title: string = '网络货运平台8大核心要求'
  content5SubTitle: string = '平台满足8大核心功能要求兼容各省监管平台'
  content5List: any = [
    {
      title: '信息发布',
      content: '实时发布真实、有效的货源及运力信息',
      img: '/static/compress-img/product/networkFreight/5-2-1.png',
    },
    {
      title: '线上交易',
      content: '车、货智能匹配，完成线上交易',
      img: '/static/compress-img/product/networkFreight/5-2-2.png',
    },
    {
      title: '全程监控',
      content: '支持自行或第三方平台对运输地点、轨迹、状态进行动态监控',
      img: '/static/compress-img/product/networkFreight/5-2-3.png',
    },
    {
      title: '金融支付',
      content: '核销对账、查询交易明细、生成资金流水单、在线支付',
      img: '/static/compress-img/product/networkFreight/5-2-4.png',
    },
    {
      title: '咨询投诉',
      content: '为用户提供咨询、举报投诉、结果反馈等服务',
      img: '/static/compress-img/product/networkFreight/5-2-5.png',
    },
    {
      title: '在线评价',
      content: '平台对托运人或实际承运人进行评级、信用打分',
      img: '/static/compress-img/product/networkFreight/5-2-6.png',
    },
    {
      title: '查询统计',
      content: '提供运单、资金流水、运输轨迹、信用记录、投诉处理等数据查询和统计服务',
      img: '/static/compress-img/product/networkFreight/5-2-7.png',
    },
    {
      title: '数据调取',
      content: '支持交通运输、税务等相关部门依法调取系统内所有数据',
      img: '/static/compress-img/product/networkFreight/5-2-8.png',
    },
  ]
  content6Title: string = '增值服务'
  content6SubTitle: string = '数百+特色功能模块可灵活配置，满足不同行业需求'
  content6List: any = [
    {
      title: '轨迹定位',
      content: '双模定位，在线查询货物实时位置\n以及历史轨迹追溯，验证物流运输的真实性和安全性',
      img: '/static/compress-img/product/networkFreight/6/1.png'
    },

    {
      title: '在线支付',
      content: '支持银企直连对接，实现运费在线支付、司机在线提现等多场景应用',
      img: '/static/compress-img/product/networkFreight/6/2.png'
    },

    {
      title: '金融服务',
      content: '利用区块链技术，和金融企业合作，通过核验业务数据的真实性、金融企业垫资授信运费',
      img: '/static/compress-img/product/networkFreight/6/3.png'
    },

    {
      title: '电子油卡',
      content: '向司机油卡账户充值，作为运费的一部分，司机在全国油网点消费，帮助平台取得进项发票',
      img: '/static/compress-img/product/networkFreight/6/4.png'
    },

    {
      title: '电子合同',
      content: '通过数字签名技术，在线生成电子合同，实现承运合同在线签署',
      img: '/static/compress-img/product/networkFreight/6/5.png'
    },

    {
      title: 'ETC电子发票',
      content: '对运单的收发地址，在线申请ETC过路过桥电子票，获得3%及以上的进项抵扣',
      img: '/static/compress-img/product/networkFreight/6/6.png'
    },

    {
      title: 'OCR识别',
      content: '身份证、驾驶证、行驶证、车牌等自动识别审核，提高用户可操作性',
      img: '/static/compress-img/product/networkFreight/6/7.png'
    },

    {
      title: '实名认证',
      content: '精准校验姓名和身份证号码或通过人像比对模式，快速完成用户身份核验',
      img: '/static/compress-img/product/networkFreight/6/8.png'
    },

    {
      title: '车辆核验',
      content: '在线全自动核验车牌号、发动机号、行驶证、道路运输证等信息的真实性核验',
      img: '/static/compress-img/product/networkFreight/6/9.png'
    },

    {
      title: '短信服务',
      content: '各业务流程中重要节点，平台通过短信模式给相关人员发送短信通知，确保信息准确送达',
      img: '/static/compress-img/product/networkFreight/6/10.png'
    },

    {
      title: '标识服务',
      content: '平台全流程赋码，一键扫码获取全流程信息',
      img: '/static/compress-img/product/networkFreight/6/11.png'
    },

    {
      title: '数据大屏',
      content: '快速定制适配各种数据大屏展示',
      img: '/static/compress-img/product/networkFreight/6/12.png'
    },
  ]
  content7Title: string = '适用行业'
  content7SubTitle: string = '定制行业解决方案包括但不限于以下行业'
  content7List: any = [
    {
      title: '家电',
      img: '/static/compress-img/product/networkFreight/7/2-1.png',
      bg: '/static/compress-img/product/networkFreight/7/1-1.png',
    },
    {
      title: '快消品',
      img: '/static/compress-img/product/networkFreight/7/2-2.png',
      bg: '/static/compress-img/product/networkFreight/7/1-2.png',
    },
    {
      title: '煤炭',
      img: '/static/compress-img/product/networkFreight/7/2-3.png',
      bg: '/static/compress-img/product/networkFreight/7/1-3.png',
    },
    {
      title: '汽贸',
      img: '/static/compress-img/product/networkFreight/7/2-4.png',
      bg: '/static/compress-img/product/networkFreight/7/1-4.png',
    },
    {
      title: '钢铁',
      img: '/static/compress-img/product/networkFreight/7/2-5.png',
      bg: '/static/compress-img/product/networkFreight/7/1-5.png',
    },
    {
      title: '建材',
      img: '/static/compress-img/product/networkFreight/7/2-6.png',
      bg: '/static/compress-img/product/networkFreight/7/1-6.png',
    },
    {
      title: '化工',
      img: '/static/compress-img/product/networkFreight/7/2-7.png',
      bg: '/static/compress-img/product/networkFreight/7/1-7.png',
    },
    {
      title: '粮食',
      img: '/static/compress-img/product/networkFreight/7/2-8.png',
      bg: '/static/compress-img/product/networkFreight/7/1-8.png',
    },

  ]
  content8Title: string = '来货拉货主版'
  content8SubTitle: string = '超好用的司机找货神器，货源覆盖全国，真实可靠'
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/product/NetworkFreight.vue